// extracted by mini-css-extract-plugin
module.exports = {"stars":"JabraStarRating_stars__g1w9l"};